import { render, staticRenderFns } from "./EmbeddedOkThxBai.vue?vue&type=template&id=2d96f875&scoped=true"
import script from "./EmbeddedOkThxBai.vue?vue&type=script&lang=js"
export * from "./EmbeddedOkThxBai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96f875",
  null
  
)

export default component.exports